import { ActiveFilters } from '../components/content/FilterSidebar';

/**
 * Count the number of individual filter selections in an ActiveFilters object.
 *
 * - Each entry in an array filter contributes 1 (e.g. 3 mimeTypes → +3)
 * - Each selected tag across all tagGroupFilters contributes 1
 * - dateRange contributes 1 if either bound is set
 * - rating contributes 1 if narrowed from the full default range (min !== 1 || max !== 5)
 * - Each boolean filter contributes 1 when true
 *
 * Extracted from FilterSidebar.tsx so the sidebar header badge and the
 * Content page's Filters toggle button share a single source of truth.
 */
export function activeFilterCount(filters: ActiveFilters): number {
  let count = 0;
  Object.entries(filters).forEach(([key, value]) => {
    if (key === 'dateRange') {
      const range = value as ActiveFilters['dateRange'];
      if (range.start || range.end) count++;
    } else if (key === 'rating') {
      const rating = value as ActiveFilters['rating'];
      if (rating.min !== 1 || rating.max !== 5) count++;
    } else if (key === 'tagGroupFilters') {
      Object.values(value as Record<string, string[]>).forEach((tagIds) => {
        count += tagIds.length;
      });
    } else if (typeof value === 'boolean') {
      if (value) count++;
    } else if (Array.isArray(value) && value.length > 0) {
      count += value.length;
    }
  });
  return count;
}
